import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorksDocuments(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,
		dtConfig[ModulesMap.DONE_WORKS_DOCUMENTS].getDoneWorksDocuments,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}
function getDoneWorksDocumentPreview(companyId, doneWorkId, documentId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,
		dtConfig[ModulesMap.DONE_WORKS_DOCUMENTS].getDoneWorksDocumentPreview,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				documentId,
			},
		},
	)
}
function getDoneWorksDocumentPopup(companyId, doneWorkId, documentId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,
		dtConfig[ModulesMap.DONE_WORKS_DOCUMENTS].getDoneWorksDocumentPopup,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				documentId,
			},
		},
	)
}

function createDoneWorksDocument(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,dtConfig[ModulesMap.DONE_WORKS_DOCUMENTS].createDoneWorksDocument, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function getDoneWorksDocument(companyId, doneWorkId, documentId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,dtConfig[ModulesMap.DONE_WORKS_DOCUMENTS].getDoneWorksDocument, {
		urlParams: {
			companyId,
			doneWorkId,
			documentId,
		},
	})
}

function patchDoneWorksDocument(companyId, doneWorkId, documentId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,dtConfig[ModulesMap.DONE_WORKS_DOCUMENTS].patchDoneWorksDocument, {
		urlParams: {
			companyId,
			doneWorkId,
			documentId,
		},
		...data,
	})
}

function putDoneWorksDocument(companyId, doneWorkId, documentId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,dtConfig[ModulesMap.DONE_WORKS_DOCUMENTS].putDoneWorksDocument, {
		urlParams: {
			companyId,
			doneWorkId,
			documentId,
		},
		...data,
	})
}

function deleteDoneWorksDocument(companyId, doneWorkId, documentId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,dtConfig[ModulesMap.DONE_WORKS_DOCUMENTS].deleteDoneWorksDocument, {
		urlParams: {
			companyId,
			doneWorkId,
			documentId,
		},
	})
}

export default {
	getDoneWorksDocuments,
	getDoneWorksDocumentPopup,
	getDoneWorksDocumentPreview,
	getDoneWorksDocument,
	patchDoneWorksDocument,
	putDoneWorksDocument,
	createDoneWorksDocument,
	deleteDoneWorksDocument,
}
